import { render, staticRenderFns } from "./Motivasi.vue?vue&type=template&id=352850f4&"
import script from "./Motivasi.vue?vue&type=script&lang=js&"
export * from "./Motivasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports